import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';

export default createReducer(
  {
    subscribed: false,
    error: false
  },
  {
    [ActionTypes.NEWSLETTER_SUBSCRIPTION_SUCCESS]: state =>
      Object.assign({}, state, { subscribed: true, error: false }),
    [ActionTypes.NEWSLETTER_SUBSCRIPTION_ERROR]: state =>
      Object.assign({}, state, { subscribed: false, error: true })
  }
);
